<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "GameManagerGame",
  components: {},
  created() {
    const ownerCurrentGame = this.$store.getters.ownerCurrentGame;
    /*if (!ownerCurrentGame) {
      this.$router.push({ name: "GameManager.allGames" });
    }*/
  },
};
</script>
